// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__31h-d","log":"ModalInventoryLogs_log__3yH0i","date":"ModalInventoryLogs_date__2xhsO","userName":"ModalInventoryLogs_userName__WA_eM"};